export const CONSOLE_LOGIN_PERMISSIONS = ['admin.console.login', 'console.login'];
export const CONSOLE_LOGIN_PERMISSIONS_ERROR = 'NoConsoleLoginPermission';

export const API_AUTHORITY_LOGIN_CONFIG_PATH = '/api/v3/LoginConfiguration';
export const API_TOTP_CREATE_SECRET_KEY_PATH = '/api/v9/totp-auth-factor/create-secret-key';
export const API_TOTP_COMPLETE_CONFIG_PATH = '/api/v9/totp-auth-factor/complete-configuration';
